import React from 'react';
import styled from 'styled-components';
import { colors, typography } from '../../../styles/theme';
import { PrimaryButton } from '../common/Buttons';

const TabWrapper = styled.div`
  margin-bottom: 24px;
`;

const TabHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const TabContainer = styled.div`
  display: flex;
  gap: 2px;
  padding: 4px;
  border-radius: 12px;
  width: fit-content;
`;

const TabSeparator = styled.div`
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
  width: 100%;
`;

const Tab = styled.button`
  padding: 8px 16px;
  border: none;
  background: ${props => props.active ? 'white' : 'transparent'};
  color: ${props => props.active ? colors.primary : colors.text.secondary};
  border-radius: 8px;
  cursor: pointer;
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.base};
  font-weight: ${typography.fontWeight.medium};
  line-height: 1.5;
  transition: all 0.2s ease;

  &:hover {
    background: ${colors.accent}10;
  }
`;

const HeaderButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const PolicyTabs = ({ 
  tabs, 
  activeTab, 
  onTabChange,
  actions,
  showSeparator = true
}) => {
  return (
    <TabWrapper>
      <TabHeader>
        <TabContainer>
          {tabs.map(tab => (
            <Tab
              key={tab.id}
              active={activeTab === tab.id}
              onClick={() => onTabChange(tab.id)}
            >
              {tab.label}
            </Tab>
          ))}
        </TabContainer>
        {actions && (
          <HeaderButtonGroup>
            {actions}
          </HeaderButtonGroup>
        )}
      </TabHeader>
      {showSeparator && <TabSeparator />}
    </TabWrapper>
  );
};

export default PolicyTabs; 